<ng-container *ngIf="productView">
  @if (productView.hasMultipleAvailableVariants) {
    <button
      class="options-button"
      mat-flat-button
      color="primary"
      [routerLink]="productView.detailUrl"
      [queryParams]="{ variant: productView.variantAvailability.variant_id }"
      queryParamsHandling="merge"
      [xButtonSize]="buttonSize"
    >
      Options
    </button>
  } @else {
    <ng-container *ngIf="productView.variantAvailability as availability">
      <x-add-to-cart-button
        [label]="
          availability.availabilityView?.unavailableReason?.label ?? productView.addToCartLabel
        "
        [disabled]="availability.availabilityView?.status | unavailableStatus"
        [disabledTooltip]="availability.availabilityView?.unavailableReason?.description"
        [bagQuantity]="availability.bagQuantity"
        [loading]="loading"
        (quantityChanged)="quantityChanged.emit($event)"
        [mode]="availability.bagQuantity > 0 ? 'controls-only' : 'no-controls'"
        [buttonSize]="buttonSize"
        [maxAvailableQuantity]="availability.maxAvailableQuantity"
      ></x-add-to-cart-button>
    </ng-container>
  }
</ng-container>
